import { render, staticRenderFns } from "./message_modal.vue?vue&type=template&id=a43e489c&scoped=true&lang=html&"
import script from "./message_modal.vue?vue&type=script&lang=js&"
export * from "./message_modal.vue?vue&type=script&lang=js&"
import style0 from "./message_modal.vue?vue&type=style&index=0&id=a43e489c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43e489c",
  null
  
)

export default component.exports